import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// Lazy load the Dashboard component for better performance
const Dashboard = lazy(() =>
  import('@features/dashboard/components/Dashboard').then((module) => ({
    default: module.Dashboard,
  }))
);

export const Route = createFileRoute('/_auth/dashboard')({ component: DashboardComponent });

function DashboardComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <Dashboard />
    </Suspense>
  );
}
